import fetch from "../utils/fetch";
import { environment } from '../environment';

const firstSlash = /^\//g;

const fetchLeadsAPI = (url, opts = {}) => {
  return fetch(
    `${environment.leadsAPIRoot}/${url.replace(firstSlash, "")}`,
    opts
  );
};

export default fetchLeadsAPI;
